import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { productService } from '../../services/api';
import Loading from '../../components/Loading';

const AdminProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await productService.getAll();
      setProducts(response.data.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('هل أنت متأكد من حذف هذا المنتج؟')) {
      try {
        await productService.delete(id);
        setProducts(products.filter(p => p.id !== id));
        alert('تم حذف المنتج بنجاح');
      } catch (error) {
        console.error('Error deleting product:', error);
        alert('فشل حذف المنتج');
      }
    }
  };

  if (loading) return <Loading />;

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex flex-row-reverse justify-between items-center mb-8">
        <h1 className="text-4xl font-bold">إدارة المنتجات</h1>
        <Link
          to="/admin/products/add"
          className="bg-primary text-white px-6 py-3 rounded-lg hover:bg-blue-700"
        >
          + إضافة منتج جديد
        </Link>
      </div>

      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الإجراءات</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الحالة</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الكمية</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">السعر</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">القسم</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">اسم المنتج</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الرقم</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {products.map(product => (
              <tr key={product.id}>
                <td className="px-6 py-4 whitespace-nowrap text-sm">
                  <div className="flex gap-2">
                    <Link
                      to={`/admin/products/edit/${product.id}`}
                      className="text-blue-600 hover:text-blue-900"
                    >
                      تعديل
                    </Link>
                    <button
                      onClick={() => handleDelete(product.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      حذف
                    </button>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {product.is_active ? (
                    <span className="px-2 py-1 text-xs bg-green-100 text-green-800 rounded">نشط</span>
                  ) : (
                    <span className="px-2 py-1 text-xs bg-red-100 text-red-800 rounded">غير نشط</span>
                  )}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{product.stock_quantity}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{product.price} د.ع</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{product.category_name}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{product.name}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{product.id}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminProducts;
